interface IRequestError extends Record<string, string | string[]> {
  detail: string;
  type: string;
  traceback: string;
}

export const isApiError = (value: unknown): value is IRequestError => {
  const error = value as IRequestError;

  const isDetail =
    typeof error?.detail === 'string' ||
    Array.isArray(error?.detail) ||
    (typeof error?.detail === 'object' && error?.detail !== null);

  return (
    (typeof isDetail && typeof error?.traceback === 'string') ||
    error?.type === 'Error'
  );
};
